import Login from "./components/Authentication/Login/Login";
import RequestAccess from "./components/RequestAccess/RequestAccess";
import Registration from "./components/Registration/Registration";
import InvalidToken from "./components/InvalidToken/InvalidToken";
import Expiration from "./components/Expiration/Expiration";
import ThankYoupage from "./components/Thankyoupage/Thankyoupage";
import VerifiedEmail from "./components/VerifiedEmail/VerifiedEmail";
import Profile from "./components/Profile/Profile.jsx";
import PageNotFound from "./components/PageNotFound/PageNotFound";

const routes = [
  {
    path: "/",
    exact: true,
    component: Login,
  },
  {
    path: "/request-access",
    component: RequestAccess,
  },
  {
    path: "/register",
    component: Registration,
  },
  {
    path: "/invalid-token",
    component: InvalidToken,
  },
  {
    path: "/(verification-expired|account-verification|registration-expired)/",
    component: Expiration,
  },
  {
    path: "/(invoice|license|download|member|profile|upgrade)/",
    component: Profile,
  },
  {
    path: "/thankyou",
    component: ThankYoupage,
  },
  {
    path: "/verify-email",
    component: VerifiedEmail,
  },
  // {
  //   path: "*",
  //   exact: true,
  //   component: PageNotFound,
  // },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js